import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import customer_router from "./customer_router";
import admin_router from "./admin_router";
import login_router from "./login_router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons"; 
import InstantSearch from "vue-instantsearch";
import JsonCSV from 'vue-json-csv';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import PrimeVue from 'primevue/config';
import axios from 'axios';
import { Auth0Plugin } from "./auth";
import { domain, clientId } from "../auth_config.json";

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  redirectUri: window.location.origin + "/authentication/auth0-callback",
  onRedirectCallback: appState => {
    // Clear URL parameters immediately
    window.history.replaceState({}, document.title, window.location.pathname);
    
    // If targetUrl exists, we'll use it if the app is already mounted
    // Otherwise bootstrap will handle the initial view based on auth state
    if (appState && appState.targetUrl && router.app) {
      router.push(appState.targetUrl);
    }
  }
});

Vue.use(PrimeVue);

Vue.use(Donut);

Vue.use(VueSweetalert2);

Vue.component('downloadCsv', JsonCSV);

Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

Vue.prototype.$adminapiurl = '/';
Vue.prototype.$apiurl = '/';

console.log('ABCCHECK---------------->');

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    axios.get(Vue.prototype.$apiurl + "api/web/common/auth-check").catch(() => {});
  }
});
let sessionInterval = null;

function startSessionPolling() {
  if (sessionInterval) return;

  sessionInterval = setInterval(() => {
																			
    axios.get(Vue.prototype.$apiurl + "api/web/common/auth-check").catch(() => {
      // interceptor handles logout
    });
  }, 5000); // every 5 seconds
}

if (localStorage.getItem("token")) {
  startSessionPolling();
}


axios.interceptors.response.use(
  response => response,
  error => {
    let raw = error.response?.data;

    // console.log(error.response.data);
    // console.log(error.response.data[0].status);
    // console.log(error.response.data.status);
    // console.log(error.response.data[0]['status']);
    // console.log('123check------------>');

    // Body-parsed status takes priority over HTTP status. The backend's
    // LoggerBehavior mangles 401 responses into HTTP 500 with a print_r'd
    // exception body — the actual auth status only survives in the body's
    // "[status] => 401" line. HTTP status is the fallback for well-formed
    // responses (real 500s, plain 401s, etc.).
    const status = (typeof raw === "object" && raw !== null && (raw.status || raw.code))
      || (typeof raw === "string" && (() => {
          const match = raw.match(/\[status\]\s*=>\s*(\d+)/);
          return match ? parseInt(match[1], 10) : null;
        })())
      || error.response?.status;

    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      localStorage.clear();
      window.location.href = "/authentication/logout";
    }

    return Promise.reject(error);
  }
);


async function bootstrap() {
  try {
    const res = await axios.get(Vue.prototype.$apiurl + "api/web/site/get-maintenance-status")
    const status = res.data.data[0].status // "ON" or "OFF"
    const maintenance = status === 'ON'

    store.commit('SET_MAINTENANCE', maintenance)

    console.log('main.js-------->');
  } catch (err) {
    console.error('Failed to load maintenance status', err) 
  }

  // Wait for Auth0 to finish loading
   const waitForAuth = () => {
     return new Promise(resolve => {
       if (Vue.prototype.$auth && !Vue.prototype.$auth.loading) {
         return resolve();
       }
       const unwatch = Vue.prototype.$auth.$watch("loading", loading => {
         if (!loading) {
           unwatch();
           resolve();
         }
       });
     });
   };

   await waitForAuth();

    if (Vue.prototype.$auth.isAuthenticated) {
      const user = Vue.prototype.$auth.user;
      const _data = [
        { username: user.nickname || user.name },
        { email: user.email },
        { site_id: 1 }, // Default site_id for Auth0 users
        { user_type: "Customer" }, // Default user_type for Auth0 users
        { status: "Active" },
        { avatar: user.picture || "test.png" },
        { user_id: user.sub },
        { admin_id: "" },
        { firstname: user.given_name || "" },
        { lastname: user.family_name || "" }
      ];
      localStorage.setItem("users", JSON.stringify(_data));
      localStorage.setItem("isAuthenticated", "true");
      
      // Ensure a token exists for interceptors
      if (!localStorage.getItem("token")) {
        localStorage.setItem("token", "auth0_active_session");
      }
    }

    let users = JSON.parse(localStorage.getItem("users"));
  console.log(users);
  console.log('jan9------->');
  let user_type = '';
  let site_id = '';
  if (users != null && Array.isArray(users)) {
    // Robustly find user_type and site_id in the array of objects
    const userTypeObj = users.find(obj => obj && Object.prototype.hasOwnProperty.call(obj, 'user_type'));
    const siteIdObj = users.find(obj => obj && Object.prototype.hasOwnProperty.call(obj, 'site_id'));
    
    user_type = userTypeObj ? userTypeObj.user_type : '';
    site_id = siteIdObj ? siteIdObj.site_id : '';
  }
  if(user_type == ''){
    new Vue({
      vuetify,
      store,
      router:login_router,
      render: (h) => h(App),
    }).$mount("#app");
  }
  else if(user_type == 'Customer'){
    new Vue({
      vuetify,
      store,
      router:customer_router,
      render: (h) => h(App),
    }).$mount("#app");
  }else if(site_id == 0){
    new Vue({
      vuetify,
      store,
      router:admin_router,
      render: (h) => h(App),
    }).$mount("#app");
  }else{
    new Vue({
      vuetify,
      store,
      router:router,
      render: (h) => h(App),
    }).$mount("#app");
  }

  // new Vue({
  //   router,
  //   store,
  //   render: h => h(App)
  // }).$mount('#app')
}

bootstrap()